import i18n from "@/i18n";
import { ContractsTypes } from "../data/enums/contractsTypes";

/**Тип счёта. */
export default function contractType(contractType: ContractsTypes): string {
  let type: any = "";

  switch (contractType) {
    case ContractsTypes.None:
      type = "";
      break;
    case ContractsTypes.CurrentAccount:
      type = i18n.t("main.contracts.types.current");
      break;
    case ContractsTypes.DepositAccounts:
      type = i18n.t("main.contracts.types.deposit");
      break;
    case ContractsTypes.TimeAccounts:
      type = i18n.t("main.contracts.types.time");
      break;
    case ContractsTypes.CardAccount:
      type = i18n.t("main.contracts.types.card");
      break;
    case ContractsTypes.CreditAccount:
      type = i18n.t("main.contracts.types.credit");
      break;
  }

  return type;
}
